"use client";
import { createGlobalStyle } from "styled-components";
import VWHeadBold from "./VWHeadWeb-Bold.woff2.js";
import VWHeadExtraBold from "./VWHeadWeb-ExtraBold.woff2.js";
import VWHeadRegular from "./VWHeadWeb-Regular.woff2.js";
import VWTextBold from "./VWTextWeb-Bold.woff2.js";
import VWTextRegular from "./VWTextWeb-Regular.woff2.js";
const VWFont = createGlobalStyle`
@font-face {
    font-family: 'VW Head';
    src: url(${VWHeadRegular});
    font-weight: 400;
}

@font-face {
    font-family: 'VW Head';
    src: url(${VWHeadBold});
    font-weight: 500;
}

@font-face {
    font-family: 'VW Head';
    src: url(${VWHeadExtraBold});
    font-weight: 600;
}

@font-face {
    font-family: 'VW Text';
    src: url(${VWTextRegular});
    font-weight: 400;
}

@font-face {
    font-family: 'VW Text';
    src: url(${VWTextBold});
    font-weight: 500;
}
`;
export {
  VWFont
};
